import { app } from './firebaseApp';

let analyticsPromise;

const scheduleIdleTask = (callback) => {
  if (typeof window === 'undefined') return;

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback, { timeout: 2000 });
    return;
  }

  window.setTimeout(callback, 1200);
};

const getAnalyticsClient = async () => {
  if (typeof window === 'undefined') return null;

  if (!analyticsPromise) {
    analyticsPromise = import('firebase/analytics')
      .then(async ({ getAnalytics, isSupported, logEvent }) => {
        const supported = await isSupported().catch(() => false);
        if (!supported) return null;

        return {
          analytics: getAnalytics(app),
          logEvent,
        };
      })
      .catch(() => null);
  }

  return analyticsPromise;
};

export const trackInitialPageView = () => {
  scheduleIdleTask(async () => {
    const client = await getAnalyticsClient();
    if (!client) return;

    client.logEvent(client.analytics, 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
    });
  });
};

export const trackWebVital = (metric) => {
  scheduleIdleTask(async () => {
    const client = await getAnalyticsClient();
    if (!client) return;

    client.logEvent(client.analytics, 'web_vitals', {
      event_category: 'Web Vitals',
      event_label: metric.id,
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      metric_name: metric.name,
      non_interaction: true,
    });
  });
};
